import { all, call, put } from 'redux-saga/effects';

import { ISubscriptionWellfunnel } from 'api/components/Subscriptions/types';

import { openModal } from 'store/modals/actions';
import { cancelSubscription, setCancellationCandidates } from 'store/subscriptions/actions';
import { checkAllCancelledSubscriptions } from 'store/subscriptions/helpers';

import { sendAnalyticSubscriptionCancelError } from 'services/Analytics';

import { ModalName } from 'modals/types';

import { callErrorCancellingBehaviour } from './callErrorCancellingBehaviour';
import { callSuccessCancellingBehaviour } from './callSuccessCancellingBehaviour';
import { callUnsubscribe } from './callUnsubscribe';
import { pollGetSubscriptions } from './pollGetSubscriptions';

export function* makeSubscriptionCancelling({
    payload: { cancellationCandidates },
}: ReturnType<typeof cancelSubscription>) {
    const successCount = { current: 0 };
    const errorCount = { current: [] };

    yield put(
        openModal(ModalName.WithLoaderModal, {
            title: 'subscription.withLoaderModal.cancellingPlan',
            img: null,
        })
    );

    try {
        yield all(
            cancellationCandidates.map((candidate) => call(callUnsubscribe, candidate, successCount, errorCount))
        );

        successCount.current = 1;
    } catch (error) {
        const [firstSubscription] = cancellationCandidates;

        yield call(sendAnalyticSubscriptionCancelError, firstSubscription.external_id);
    } finally {
        const successTotal = successCount.current;
        const errorTotal = errorCount.current.length;

        if (errorTotal > 0) {
            yield call(callErrorCancellingBehaviour, { errorCount, cancellationCandidates });
        } else if (successTotal > 0) {
            const candidateIds = cancellationCandidates.map(({ external_id }) => external_id);
            const freshSubscriptions: ISubscriptionWellfunnel[] = yield call(
                pollGetSubscriptions,
                checkAllCancelledSubscriptions(cancellationCandidates)
            );
            const freshCandidates = freshSubscriptions.filter(({ external_id }) => candidateIds.includes(external_id));

            yield put(setCancellationCandidates(freshCandidates));
            yield call(callSuccessCancellingBehaviour, {
                cancellationCandidates: freshCandidates,
            });
        }
    }
}
